// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `#typography .small-text {
  color: #fff;
  /* Text 1 */
  font-size: 12rem;
  font-style: normal;
  font-weight: 400;
  line-height: 150%;
  letter-spacing: 0.2rem;
}
@media (max-width: 660px) {
  #typography .small-text {
    font-size: 9rem;
  }
}
#typography .medium-text {
  color: #fff;
  font-size: 15rem;
  font-style: normal;
  font-weight: 400;
  line-height: normal;
}
@media (max-width: 660px) {
  #typography .medium-text {
    font-size: 12rem;
  }
}
#typography .sub-title {
  color: #fff;
  /* H1 Headline */
  font-size: 20rem;
  font-style: normal;
  font-weight: 600;
  line-height: 32px;
}
@media (max-width: 660px) {
  #typography .sub-title {
    font-size: 17rem;
  }
}
#anim .reveal[visible] {
  opacity: 1;
  transform: translateX(0) translateY(0) rotate(0deg);
}
.footer {
  padding: 0 99rem 71rem;
  display: flex;
  flex-direction: column;
  gap: 28rem;
}
@media (max-width: 660px) {
  .footer {
    padding: 0 30rem 71rem;
  }
}
.footer .logo-container {
  display: flex;
  align-items: center;
}
.footer .logo-container a.campaign-link {
  display: flex;
  align-items: center;
}
.footer .logo-container .ord-footer {
  width: 77rem;
}
.footer .logo-container .divider {
  margin-right: 17rem;
  margin-left: 17rem;
}
.footer .logo-container .sber-footer {
  width: 106rem;
}
.footer .footer-info {
  width: 80%;
  display: flex;
  justify-content: space-between;
}
@media (max-width: 660px) {
  .footer .footer-info {
    width: 100%;
  }
}
.footer .footer-info .block {
  display: flex;
  flex-direction: column;
}
.footer .footer-info .block .description {
  color: rgba(255, 255, 255, 0.7);
  font-size: 12px;
  font-style: normal;
  font-weight: 400;
  line-height: 23.19px;
  /* 193.25% */
}
@media (max-width: 660px) {
  .footer .footer-info .block .description {
    font-size: 5rem;
  }
}
.footer .footer-info .block .text {
  color: #fff;
  /* Text 1 */
  font-size: 12rem;
  font-style: normal;
  font-weight: 400;
  line-height: 150%;
  letter-spacing: 0.2rem;
}
@media (max-width: 660px) {
  .footer .footer-info .block .text {
    font-size: 9rem;
  }
}
@media (max-width: 660px) {
  .footer .footer-info .block .text {
    font-size: 6rem;
  }
}
.footer .footer-info .block .text .footer-mail-to {
  color: #45E6EB;
}
.footer .footer-horizontal-divider {
  width: 100%;
  height: 1rem;
  opacity: 0.2;
  background-color: #D6F3FA;
}
.footer .footer-link {
  display: flex;
  justify-content: space-between;
}
@media (max-width: 660px) {
  .footer .footer-link {
    gap: 5%;
  }
}
.footer .footer-link a {
  color: #fff;
  /* Text 1 */
  font-size: 12rem;
  font-style: normal;
  font-weight: 400;
  line-height: 150%;
  letter-spacing: 0.2rem;
  color: #45E6EB;
}
@media (max-width: 660px) {
  .footer .footer-link a {
    font-size: 9rem;
  }
}
@media (max-width: 660px) {
  .footer .footer-link a {
    font-size: 6rem;
  }
}
`, "",{"version":3,"sources":["webpack://./src/app/styles/mixins.style.less","webpack://./src/widgets/Footer/ui/Footer.style.less"],"names":[],"mappings":"AAAA;EAEQ,WAAA;ECAN,WAAW;EDEL,gBAAA;EACA,kBAAA;EACA,gBAAA;EACA,iBAAA;EACA,sBAAA;ACAR;ADEQ;EAAA;IACI,eAAA;ECCV;AACF;ADbA;EAgBQ,WAAA;EACA,gBAAA;EACA,kBAAA;EACA,gBAAA;EACA,mBAAA;ACAR;ADCQ;EAAA;IACI,gBAAA;ECEV;AACF;ADzBA;EA2BQ,WAAA;ECCN,gBAAgB;EDCV,gBAAA;EACA,kBAAA;EACA,gBAAA;EACA,iBAAA;ACCR;ADAQ;EAAA;IACI,gBAAA;ECGV;AACF;ADUQ;EACI,UAAA;EACA,mDAAA;ACRZ;AAxCA;EACI,sBAAA;EACA,aAAA;EACA,sBAAA;EACA,UAAA;AA0CJ;AAzCI;EAAA;IACI,sBAAA;EA4CN;AACF;AAnDA;EASQ,aAAA;EACA,mBAAA;AA6CR;AAvDA;EAYY,aAAA;EACA,mBAAA;AA8CZ;AA3DA;EAgBY,YAAA;AA8CZ;AA9DA;EAmBY,mBAAA;EACA,kBAAA;AA8CZ;AAlEA;EAuBY,aAAA;AA8CZ;AArEA;EA4BQ,UAAA;EACA,aAAA;EACA,8BAAA;AA4CR;AA3CQ;EAAA;IACI,WAAA;EA8CV;AACF;AA/EA;EAmCY,aAAA;EACA,sBAAA;AA+CZ;AAnFA;EAsCgB,+BAAA;EACA,eAAA;EACA,kBAAA;EACA,gBAAA;EACA,oBAAA;EAgDd,YAAY;AACd;AAhDgB;EAAA;IACI,eAAA;EAmDlB;AACF;AAhGA;EDAQ,WAAA;ECmGN,WAAW;EDjGL,gBAAA;EACA,kBAAA;EACA,gBAAA;EACA,iBAAA;EACA,sBAAA;ACmGR;ADjGQ;EAAA;IACI,eAAA;ECoGV;AACF;AA5DgB;EAAA;IACI,eAAA;EA+DlB;AACF;AAnHA;EAsDoB,cAAA;AAgEpB;AAtHA;EA6DO,WAAA;EACA,YAAA;EACA,YAAA;EACA,yBAAA;AA4DP;AA5HA;EAoEQ,aAAA;EACA,8BAAA;AA2DR;AA1DQ;EAAA;IACI,OAAA;EA6DV;AACF;AArIA;EDAQ,WAAA;ECwIN,WAAW;EDtIL,gBAAA;EACA,kBAAA;EACA,gBAAA;EACA,iBAAA;EACA,sBAAA;ECqEI,cAAA;AAoEZ;ADvIQ;EAAA;IACI,eAAA;EC0IV;AACF;AAxEY;EAAA;IACI,eAAA;EA2Ed;AACF","sourcesContent":["#typography {\n    .small-text {\n        color: #fff;\n        /* Text 1 */\n        font-size: 12rem;\n        font-style: normal;\n        font-weight: 400;\n        line-height: 150%;\n        letter-spacing: 0.2rem;\n\n        @media (max-width: 660px) {\n            font-size: 9rem;\n        }\n    }\n\n    .medium-text {\n        color: #fff;\n        font-size: 15rem;\n        font-style: normal;\n        font-weight: 400;\n        line-height: normal;\n        @media (max-width: 660px) {\n            font-size: 12rem;\n        }\n    }\n\n    .sub-title {\n        color: #fff;\n        /* H1 Headline */\n        font-size: 20rem;\n        font-style: normal;\n        font-weight: 600;\n        line-height: 32px;\n        @media (max-width: 660px) {\n            font-size: 17rem;\n        }\n    }\n}\n\n#anim {\n    .defaultOpacityTransforms(@delay: 0s, @transform: translateY(0rem)) {\n        transition: 0.6s opacity ease-in-out, 0.6s transform ease-in-out;\n        transition-delay: @delay;\n        transform: @transform;\n        opacity: 0;\n    }\n\n    .reveal {\n        &[visible] {\n            opacity: 1;\n            transform: translateX(0) translateY(0) rotate(0deg);\n        }\n    }\n}","@import 'mixins.style.less';\n\n.footer {\n    padding: 0 99rem 71rem;\n    display: flex;\n    flex-direction: column;\n    gap: 28rem;\n    @media (max-width: 660px) {\n        padding: 0 30rem 71rem;\n    }\n    .logo-container {\n        display: flex;\n        align-items: center;\n        a.campaign-link {\n            display: flex;\n            align-items: center;\n        }\n        .ord-footer {\n            width: 77rem;\n        }\n        .divider {\n            margin-right: 17rem;\n            margin-left: 17rem;\n        }\n        .sber-footer {\n            width: 106rem;\n        }\n    }\n\n    .footer-info {\n        width: 80%;\n        display: flex;\n        justify-content: space-between;\n        @media (max-width: 660px) {\n            width: 100%;\n        }\n        .block {\n            display: flex;\n            flex-direction: column;\n            .description {\n                color: rgba(255, 255, 255, 0.70);\n                font-size: 12px;\n                font-style: normal;\n                font-weight: 400;\n                line-height: 23.19px; /* 193.25% */\n                @media (max-width: 660px) {\n                    font-size: 5rem;\n                }\n            }\n\n            .text {\n                #typography.small-text();\n                @media (max-width: 660px) {\n                    font-size: 6rem;\n                }\n                .footer-mail-to {\n                    color: #45E6EB;\n                }\n            }\n        }\n    }\n\n    .footer-horizontal-divider {\n       width: 100%;\n       height: 1rem;\n       opacity: 0.2;\n       background-color: #D6F3FA;\n    }\n\n    .footer-link {\n        display: flex;\n        justify-content: space-between;\n        @media (max-width: 660px) {\n            gap: 5%\n        }\n        a {\n            #typography.small-text();\n            color: #45E6EB;\n            @media (max-width: 660px) {\n                font-size: 6rem;\n            }\n        }\n    }\n}"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
